import { logError } from 'src/loggingManager';
import { getSdk } from 'src/sdk';

export interface FinishData {
    id: string;
    name: string;
    scene: {
        channel: string;
        baseTexture: {
            url: string;
            dpi?: number;
        };
        bumpScale: number;
    };
}

export const getFinishList = async (): Promise<FinishData[]> => {
    try {
        const response = await getSdk().Materials.getFinishesAll();
        return response.filter((finish) => !!finish.scene);
    } catch (error) {
        const errorMsg = `Unable to retrieve finish list: ${error}`;
        logError(errorMsg);
        throw new Error(errorMsg);
    }
};
